<div>
  <div class="modal_header">
    <i class="fa-solid fa-comment fa-flip-horizontal header-icon"></i> COMMENT
  </div>
  <div class="modal__content">
    <div class="comment-subheading">
      @if (isStatementDateComment && statementDate) {
        This comment is for the period:
        <div class="comment-row-label">{{statementDate}}</div>
      } @else {
        This comment is on a cell for the line item:
      }
    </div>
    @if (!isStatementDateComment) {
      <div class="comment-row-label" appFsMask>
        {{ rowWithCell?.label }}
      </div>
    }
    <div>
      <label for="userInput" class="comment-input-label"></label>
      <textarea class="comment-input-box" id="userInput" name="userInput" value="{{ cellWithComment?.sourceComments?.[0]?.comment }}" placeholder="Add Comment" appFsMask></textarea>
    </div>
  </div>
</div>
<div class="modal__footer">
  <button type="reset" class="btn btn-link" (click)="cancel();">Cancel</button>
  <button class="btn btn-primary" (click)="saveSpreadingComment(document.getElementById('userInput'))">Save</button>
</div>
